import React from "react";
import "./404.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* 404 — design "Signal" 4h */
const NoteFounfPage = () => {
  const { t } = useTranslation();
  return (
    <div className="sg-page" style={{ maxWidth: 560, minHeight: "60vh", justifyContent: "center" }}>
      <div className="sg-panel" style={{ padding: 32, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 14 }}>
        <span style={{ font: "700 64px/1 var(--font-mono)", color: "var(--color-primary)", letterSpacing: "-0.04em" }}>
          404
        </span>
        <h1 className="sg-h1" style={{ fontSize: 24 }}>{t("signal.nf-title")}</h1>
        <p className="sg-sub" style={{ maxWidth: "44ch", fontSize: 14 }}>{t("signal.nf-body")}</p>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 4 }}>
          <Link to="/" className="sg-btn sg-btn--primary">{t("signal.nf-buy")}</Link>
          <Link to="/order-list" className="sg-btn sg-btn--ghost">{t("signal.nf-orders")}</Link>
          <Link to="/help" className="sg-btn sg-btn--ghost">{t("overview.faq-1")}</Link>
        </div>
      </div>
    </div>
  );
};

export default NoteFounfPage;
